import React from 'react';
import { NotesFilters } from '../../utils/notesFilterUtils';
import {
  SUBJECT_OPTIONS,
  UNIVERSITY_YEAR_OPTIONS,
  subjectLabels,
  universityYearLabels,
} from '../../utils/noteLabels';

type Props = {
  filters: NotesFilters;
  universities: string[];
  departments: string[];
  onChange: <K extends keyof NotesFilters>(key: K, value: NotesFilters[K]) => void;
  idSuffix?: string;
};

const NotesFilterPanel: React.FC<Props> = ({
  filters,
  universities,
  departments,
  onChange,
  idSuffix = '',
}) => {
  const uid = (name: string) => `${name}${idSuffix}`;

  return (
    <div className="notes-filter-panel">
      <div className="notes-filter-panel__group">
        <span className="notes-filter-panel__label">Ders</span>
        <div className="notes-filter-panel__chips">
          <button
            type="button"
            className={`filter-chip${!filters.subject ? ' filter-chip--active' : ''}`}
            onClick={() => onChange('subject', '')}
          >
            Tümü
          </button>
          {SUBJECT_OPTIONS.map((s) => (
            <button
              key={s}
              type="button"
              className={`filter-chip${filters.subject === s ? ' filter-chip--active' : ''}`}
              onClick={() => onChange('subject', s)}
            >
              {subjectLabels[s]}
            </button>
          ))}
        </div>
      </div>

      <div className="notes-filter-panel__row">
        <div className="notes-filter-panel__field">
          <label htmlFor={uid('university')}>Üniversite</label>
          <input
            id={uid('university')}
            list={uid('universities-list')}
            value={filters.university}
            onChange={(e) => onChange('university', e.target.value)}
            placeholder="Örn. ODTÜ, Boğaziçi…"
          />
          <datalist id={uid('universities-list')}>
            {universities.map((u) => (
              <option key={u} value={u} />
            ))}
          </datalist>
        </div>
        <div className="notes-filter-panel__field">
          <label htmlFor={uid('department')}>Bölüm</label>
          <input
            id={uid('department')}
            list={uid('departments-list')}
            value={filters.department}
            onChange={(e) => onChange('department', e.target.value)}
            placeholder="Örn. Bilgisayar Mühendisliği"
          />
          <datalist id={uid('departments-list')}>
            {departments.map((d) => (
              <option key={d} value={d} />
            ))}
          </datalist>
        </div>
      </div>

      <div className="notes-filter-panel__group">
        <span className="notes-filter-panel__label">Sınıf / yıl</span>
        <div className="notes-filter-panel__chips">
          <button
            type="button"
            className={`filter-chip${!filters.year ? ' filter-chip--active' : ''}`}
            onClick={() => onChange('year', '')}
          >
            Tümü
          </button>
          {UNIVERSITY_YEAR_OPTIONS.map((y) => (
            <button
              key={y}
              type="button"
              className={`filter-chip${filters.year === y ? ' filter-chip--active' : ''}`}
              onClick={() => onChange('year', y)}
            >
              {universityYearLabels[y]}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NotesFilterPanel;
